/* ------------------------------------------------------------------
   Aegis Guard — signature de marque : moteur du trait vert.

   Une unite = un element .ag-sig contenant un <svg class="ag-sig__svg">.
     - entree a 15 % de visibilite, sans marge : .is-drawn, le trait se
       trace de gauche a droite en 600 ms (duree definie dans le CSS) ;
     - sortie complete de l'ecran : retour a l'etat initial sans
       transition, le trait se rejoue a la prochaine entree ;
     - prefers-reduced-motion : trait affiche d'emblee, aucun mouvement.

   La page Pack Commando n'utilise pas ce moteur : ses traits portent la
   classe .ag-pk-ul et sont allumes par assets/aegis-pack.js. Ce fichier
   ne touche a aucun element .ag-pk-ul. Aucune dependance.
   ------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__agSig) return;
  window.__agSig = true;

  var W = window;
  var D = document;
  var MQ = W.matchMedia ? W.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var observer = null;

  function reduced() {
    return !!(MQ && MQ.matches);
  }

  function onEntries(entries) {
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      if (e.isIntersecting && e.intersectionRatio >= 0.15) {
        e.target.classList.add('is-drawn');
      } else if (!e.isIntersecting) {
        if (!e.target.classList.contains('is-drawn')) continue;
        e.target.classList.add('ag-sig--rearm');
        e.target.classList.remove('is-drawn');
        /* Lecture forcee : l'etat initial s'applique sans transition. */
        void e.target.offsetWidth;
        e.target.classList.remove('ag-sig--rearm');
      }
    }
  }

  function boot() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    var units = D.querySelectorAll('.ag-sig');
    if (!units.length) return;

    if (reduced() || !('IntersectionObserver' in W)) {
      for (var i = 0; i < units.length; i++) units[i].classList.add('is-drawn');
      return;
    }

    observer = new W.IntersectionObserver(onEntries, {
      threshold: [0, 0.15],
      rootMargin: '0px'
    });
    for (var j = 0; j < units.length; j++) observer.observe(units[j]);
  }

  if (D.readyState === 'loading') {
    D.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  D.addEventListener('shopify:section:load', boot);
  if (MQ) {
    if (MQ.addEventListener) {
      MQ.addEventListener('change', boot);
    } else if (MQ.addListener) {
      MQ.addListener(boot);
    }
  }
})();

/* ------------------------------------------------------------------
   Aegis Guard — menu : indicateur de la page courante.

   Sous l'entree courante des trois menus — desktop (.menu-list__link),
   barre mobile (.menu-list--mobile .menu-list__item) et tiroir
   (.menu-drawer__menu-item) — le trait signature : meme trace que les
   titres, etire a la largeur exacte du mot, 3 px, haut du trait a 6 px
   sous la ligne de base. Il se trace une fois par page, 200 ms apres le
   chargement de l'en-tete (styles dans assets/aegis-brand.css).

   Entree courante : celle qui porte aria-current="page", pose par
   Horizon. Sur les fiches produit, l'entree de la collection des plaques
   recoit .ag-nav-current et aria-current="true" : les trois finitions
   sont trois produits de cette collection.

   Barre mobile : au chargement, elle defile horizontalement, jamais la
   page, pour que l'entree courante soit entierement visible, centree si
   possible. Elle est recentree quand la largeur de la fenetre change
   (rotation du telephone), jamais quand seule la hauteur change.

   Horizon re-rend l'en-tete apres le chargement (hydratation par la
   Section Rendering API, data-hydration-key) : ce re-rendu efface le
   trait et la classe. Un MutationObserver sur l'en-tete les repose, et
   le trace attend la fin de l'hydratation (data-hydrated="true").
   Aucun fichier Horizon n'est modifie.
   ------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__agNav) return;
  window.__agNav = true;

  var W = window;
  var D = document;
  var PLAQUE = '/collections/plaque-aegis-support-nfc-qr-pour-avis-google';
  var TRACE = 'M1.5 6.6C16 3.6 33 7.8 49 4.4 65 1.6 82 6.6 98.5 3.2';
  var NS = 'http://www.w3.org/2000/svg';
  /* SVG de 10 px de haut pour une viewBox de 10 : echelle verticale 1.
     Axe moyen du trace : y = 4,76. Haut du trait de 3 px a 6 px sous la
     ligne de base, donc axe a 7,5 px : le SVG commence 7,5 - 4,76 px
     sous la ligne de base. */
  var DECALAGE = 7.5 - 4.76;
  var ENTREES = '.header-section .menu-list__link, ' +
    '.header-section .menu-list--mobile .menu-list__item, ' +
    '.header-section .menu-drawer__menu-item';
  var MQ = W.matchMedia ? W.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var hotes = [];
  var ro = null;
  var barreBoite = null;
  var barreGauche = null;
  var minuteur = null;
  var traceLance = false;
  var observe = null;
  var observateur = null;

  function reduit() {
    return !!(MQ && MQ.matches);
  }

  function chemin(a) {
    var href = a.getAttribute('href');
    if (!href) return '';
    try {
      return new URL(href, W.location.href).pathname.replace(/\/+$/, '');
    } catch (e) {
      return '';
    }
  }

  /* Fiches produit : l'entree « La plaque » devient l'entree courante. */
  function marquerFicheProduit() {
    if (!/\/products\/[^\/]+/.test(W.location.pathname)) return;
    var liens = D.querySelectorAll(ENTREES);
    for (var i = 0; i < liens.length; i++) {
      var p = chemin(liens[i]);
      if (!p || p.slice(-PLAQUE.length) !== PLAQUE) continue;
      if (!liens[i].classList.contains('ag-nav-current')) liens[i].classList.add('ag-nav-current');
      if (!liens[i].hasAttribute('aria-current')) liens[i].setAttribute('aria-current', 'true');
    }
  }

  function hoteDe(el) {
    return el.querySelector('.menu-list__link-title') ||
      el.querySelector('.menu-drawer__menu-item-text') || el;
  }

  function creerTrait() {
    var svg = D.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'ag-nav-sig');
    svg.setAttribute('viewBox', '0 0 100 10');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var path = D.createElementNS(NS, 'path');
    path.setAttribute('pathLength', '100');
    path.setAttribute('d', TRACE);
    svg.appendChild(path);
    return svg;
  }

  /* Bords du mot (derniere ligne) et ligne de base, en coordonnees ecran. */
  function mesurer(hote) {
    var tw = D.createTreeWalker(hote, NodeFilter.SHOW_TEXT, null);
    var premier = null;
    var dernier = null;
    var n;
    while ((n = tw.nextNode())) {
      if (!/\S/.test(n.nodeValue)) continue;
      if (!premier) premier = n;
      dernier = n;
    }
    if (!premier) return null;
    var r = D.createRange();
    r.setStart(premier, premier.nodeValue.search(/\S/));
    r.setEnd(dernier, dernier.nodeValue.replace(/\s+$/, '').length);
    var rects = r.getClientRects();
    if (!rects.length) return null;
    var bas = -Infinity;
    var i;
    for (i = 0; i < rects.length; i++) if (rects[i].bottom > bas) bas = rects[i].bottom;
    var g = Infinity;
    var d = -Infinity;
    for (i = 0; i < rects.length; i++) {
      var q = rects[i];
      if (!q.width || Math.abs(q.bottom - bas) > 1) continue;
      if (q.left < g) g = q.left;
      if (q.right > d) d = q.right;
    }
    if (!(d > g)) return null;
    /* Sonde de 0 x 0 alignee sur la ligne de base, retiree aussitot. */
    var sonde = D.createElement('span');
    sonde.style.cssText = 'display:inline-block;width:0;height:0;margin:0;padding:0;border:0;vertical-align:baseline';
    dernier.parentNode.insertBefore(sonde, dernier.nextSibling);
    var base = sonde.getBoundingClientRect().top;
    sonde.parentNode.removeChild(sonde);
    return { g: g, d: d, base: base };
  }

  function placer(hote) {
    var trait = hote.__agNavSig;
    if (!trait || !hote.isConnected) return;
    var hr = hote.getBoundingClientRect();
    if (!hr.width || !hr.height) return; /* menu masque : tiroir ferme, autre largeur */
    var m = mesurer(hote);
    if (!m) return;
    var ox = hr.left + (hote.clientLeft || 0);
    var oy = hr.top + (hote.clientTop || 0);
    trait.style.left = (m.g - ox) + 'px';
    trait.style.width = (m.d - m.g) + 'px';
    trait.style.top = (m.base - oy + DECALAGE) + 'px';
  }

  /* Barre mobile : defilement horizontal de la barre seule. Si le
     visiteur l'a deja fait defiler, on n'y touche plus. */
  function centrerBarre() {
    var cur = D.querySelector('.header-section .menu-list--mobile .menu-list__item[aria-current="page"], ' +
      '.header-section .menu-list--mobile .menu-list__item.ag-nav-current');
    if (!cur) return;
    var boite = cur.closest('.menu-list__scroll-container');
    if (!boite || !boite.clientWidth) return;
    if (boite !== barreBoite) {
      barreBoite = boite;
      barreGauche = null;
    }
    if (barreGauche !== null && Math.abs(boite.scrollLeft - barreGauche) > 1) return;
    var br = boite.getBoundingClientRect();
    var cr = cur.getBoundingClientRect();
    var cible = boite.scrollLeft + (cr.left - br.left) - (boite.clientWidth - cr.width) / 2;
    var max = boite.scrollWidth - boite.clientWidth;
    boite.scrollLeft = Math.max(0, Math.min(max, Math.round(cible)));
    barreGauche = boite.scrollLeft;
  }

  /* Trace unique : 200 ms apres la fin de l'hydratation de l'en-tete. */
  function lancerTrace() {
    if (minuteur !== null || traceLance) return;
    minuteur = W.setTimeout(function () {
      traceLance = true;
      var traits = D.querySelectorAll('.ag-nav-sig');
      for (var i = 0; i < traits.length; i++) traits[i].classList.add('is-drawn');
    }, reduit() ? 0 : 200);
  }

  function enteteFinal() {
    var h = D.querySelector('.header-section');
    return !h || h.getAttribute('data-hydrated') === 'true';
  }

  function demarrer() {
    marquerFicheProduit();
    if (!ro && 'ResizeObserver' in W) {
      ro = new W.ResizeObserver(function (entrees) {
        for (var k = 0; k < entrees.length; k++) placer(entrees[k].target);
      });
    }
    var liens = D.querySelectorAll(ENTREES);
    for (var i = 0; i < liens.length; i++) {
      var el = liens[i];
      if (!el.matches('[aria-current="page"], .ag-nav-current')) continue;
      var hote = hoteDe(el);
      if (hote.__agNavSig && hote.contains(hote.__agNavSig)) {
        if (!hote.classList.contains('ag-nav-host')) hote.classList.add('ag-nav-host');
        continue;
      }
      var trait = creerTrait();
      /* Trait repose apres le depart du trace : affiche d'emblee. */
      if (traceLance) {
        trait.firstChild.style.transition = 'none';
        trait.classList.add('is-drawn');
      }
      hote.classList.add('ag-nav-host');
      hote.appendChild(trait);
      hote.__agNavSig = trait;
      hotes.push(hote);
      placer(hote);
      if (ro) ro.observe(hote);
    }
    centrerBarre();
  }

  function apresPolices() {
    for (var i = 0; i < hotes.length; i++) placer(hotes[i]);
    centrerBarre();
  }

  function surveiller() {
    var h = D.querySelector('.header-section');
    if (!h || h === observe || !('MutationObserver' in W)) return;
    if (observateur) observateur.disconnect();
    observe = h;
    var prevu = false;
    observateur = new W.MutationObserver(function () {
      if (prevu) return;
      prevu = true;
      W.requestAnimationFrame(function () {
        prevu = false;
        demarrer();
        if (enteteFinal()) lancerTrace();
      });
    });
    observateur.observe(h, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-hydrated'] });
  }

  function init() {
    demarrer();
    surveiller();
    if (enteteFinal()) lancerTrace();
    /* Filet : en-tete jamais hydrate. */
    W.setTimeout(lancerTrace, 1500);
  }

  if (D.readyState === 'loading') {
    D.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  if (D.fonts && D.fonts.ready) D.fonts.ready.then(apresPolices);
  D.addEventListener('shopify:section:load', function () {
    demarrer();
    surveiller();
  });

  /* Rotation du telephone, fenetre elargie ou retrecie : quand la
     LARGEUR change, la barre mobile est recentree sur l'entree courante,
     meme si le visiteur l'avait fait defiler (en paysage, la barre
     disparait ou ne defile plus, et revient au debut). Un changement de
     hauteur seul ne relance rien : barres du navigateur qui se replient
     pendant le defilement, clavier qui s'ouvre. La largeur est lue sur
     documentElement.clientWidth, qui ne varie pas avec le zoom a deux
     doigts. */
  var largeurVue = D.documentElement.clientWidth;
  var minuteurLargeur = null;
  W.addEventListener('resize', function () {
    if (minuteurLargeur !== null) W.clearTimeout(minuteurLargeur);
    minuteurLargeur = W.setTimeout(function () {
      minuteurLargeur = null;
      var l = D.documentElement.clientWidth;
      if (l === largeurVue) return;
      largeurVue = l;
      barreGauche = null;
      centrerBarre();
    }, 150);
  });

  /* Filigrane du tiroir de menu (lot 12) : le symbole du logo, sans le
     texte, en tres grand et en vert tres pale derriere les liens. Il est
     pose a chaque ouverture du tiroir, juste avant le carrousel des
     plaques : Horizon re-rend l'en-tete apres le chargement et peut
     l'effacer. Hauteur nulle, aucun evenement de pointeur : la mise en
     page et les clics du tiroir ne changent pas. La place libre au-dessus
     du carrousel est mesuree a chaque ouverture (--ag-fil-haut). Taille,
     couches et entree : assets/aegis-brand.css. Trace sur le logo de
     l'en-tete : diagonale et jambe droite du A paralleles, trois traits
     de meme epaisseur. */
  var FILIGRANE = '<svg class="ag-fil__svg" viewBox="0 0 483.5 505.1" aria-hidden="true" focusable="false">' +
    '<defs><linearGradient id="ag-fil-degrade" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="0" y2="505.1">' +
    '<stop offset="0" stop-color="#0E6A4A" stop-opacity="0.1"/>' +
    '<stop offset="1" stop-color="#0E6A4A" stop-opacity="0.03"/>' +
    '</linearGradient></defs>' +
    '<g fill="url(#ag-fil-degrade)">' +
    '<polygon points="0,439.6 193,113.3 395.8,486.9 358.5,505.1 191.5,197.4 40.3,453.1"/>' +
    '<polygon points="219.7,42.8 243.7,0 483.5,441.5 443.8,455.4"/>' +
    '</g></svg>';

  function poserFiligrane() {
    var tiroir = D.getElementById('Details-menu-drawer-container');
    if (!tiroir || !tiroir.open) return;
    var panneau = tiroir.querySelector('.menu-drawer');
    if (!panneau) return;
    var fil = null;
    var carrousel = null;
    for (var i = 0; i < panneau.children.length; i++) {
      var c = panneau.children[i];
      if (c.classList.contains('ag-fil')) fil = c;
      else if (c.classList.contains('menu-drawer__featured-content')) carrousel = c;
    }
    if (!fil) {
      fil = D.createElement('div');
      fil.className = 'ag-fil';
      fil.setAttribute('aria-hidden', 'true');
      fil.innerHTML = FILIGRANE;
    }
    if (carrousel) {
      if (fil.nextElementSibling !== carrousel) panneau.insertBefore(fil, carrousel);
    } else if (fil.parentNode !== panneau || fil.nextElementSibling) {
      panneau.appendChild(fil);
    }
    fil.style.setProperty('--ag-fil-haut', fil.offsetTop + 'px');
  }
  D.addEventListener('toggle', function (e) {
    if (e.target && e.target.id === 'Details-menu-drawer-container') poserFiligrane();
  }, true);
  W.addEventListener('resize', poserFiligrane);
})();
